import { Formik, Form, Field } from 'formik';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router';
import * as Yup from 'yup';
import { API_BASE_URL, API_URL } from '../../utilities/constants';
import { handleApiCall } from '../../utilities/helper';
import { useUI } from '../../context/UI';

const EditModule = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();

    const [initialValues, setInitialValues] = useState({
        departmentName: "",
    });
     const fetchModuleById = async (id) => {
        setLoading(true);
        try {
            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/modules/${id}`, {

                method: "GET",
            });
            if (response.responseStatus === true) {
                setData(response.data);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log("Error:", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) fetchModuleById(id);
    }, [id]);

    useEffect(() => {
        setInitialValues({
            moduleName: data?.moduleName || null,
        })
    }, [data])
    const validationSchema = Yup.object().shape({
        moduleName: Yup.string().required('Module Name is required'),
    });

    const handleEditModule = async (value) => {
        setLoading(true);
        const payload = {
            moduleName: value.moduleName,
        };
        try {
            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/modules/${id}`, {
                method: "PUT",
                body: payload,
            });

            if (response?.result?.responseCode === 200) {
                addToastMessage({
                    status: true,
                    message:
                        "Module updated successfully. Thank You!",
                });
                navigate(`/modules`);
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully updated a Module!",
                    status: true,
                    archive: false,
                });
            }
            else {
                addToastMessage({
                    status: false,
                    message: response?.responseDescription ||
                        `Something went wrong while updating Module. Please try again.`,
                });
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            addToastMessage({
                status: false,
                message: `Something went wrong while updating Module. Please try again.`,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setSegmentTitle("Edit Module");
    }, []);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={handleEditModule}
        >
            {({ errors, touched, setFieldValue, values }) => (
                <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max- mx-auto space-y-6">

                        <div>
                            <label className="block text-sm font-medium mb-1">Module Name</label>
                            <Field
                                name="moduleName"
                                type="text"
                                placeholder='Eg: Fx Corridors.'
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                    }`}
                            />
                            {errors.moduleName && touched.moduleName && (
                                <p className="text-xs text-red-500 mt-1">{errors.moduleName}</p>
                            )}
                        </div>
                    <div className="flex justify-end gap-3 pt-4">
                         <NavLink to='/modules'>
                        <button
                            type="reset"
                            className="px-5 py-2 rounded-lg border border-gray-400 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 transition"
                        >
                            Cancel
                        </button>
                        </NavLink>
                        <button
                            type="submit"
                            className="submit-button"
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            )}
        </Formik>

    );
};



export default EditModule;


